import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ThemeRoot } from './components/ThemeRoot';
import { AuthProvider } from './lib/auth';
// tokens first — every other sheet resolves against these — then the design
// system. `global.css` is what remains of the pre-Carbon stylesheet and is
// being retired; it loads between them so ui.css still wins where they overlap.
import './styles/tokens.css';
import './styles/global.css';
import './styles/ui.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

// The router wraps the auth provider, not the other way round: the Auth0
// redirect callback returns the operator to the page they asked for, which
// needs `useNavigate`.
createRoot(container).render(
  <StrictMode>
    <ThemeRoot>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeRoot>
  </StrictMode>,
);
